<div class="w-2/3 overflow-hidden" [formGroup]="form()">
  <hlm-field>
    <label hlmLabel for="competences-compagnonniques">Compétences compagnonniques</label>
    <input id="competences-compagnonniques" hlmInput type="text" formControlName="competencesCompagnonniques" />
    <hlm-field-description>Si vide, libre au choix de l'apprenant.</hlm-field-description>
  </hlm-field>
</div>
